/** Delete a user. */
export const userDeleteSpec = {
    uri: '/user/[user]',
    method: 'DELETE',
    adminOnly: true,
};
